import { render } from "./PaymentContentFailed.vue?vue&type=template&id=3fce1d14"
import script from "./PaymentContentFailed.vue?vue&type=script&lang=js"
export * from "./PaymentContentFailed.vue?vue&type=script&lang=js"

import exportComponent from "E:\\my project backsups\\vue\\vuestyle3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__